import { useEffect } from 'react';
import { Controller, Form, useFormContext } from 'react-hook-form';
import moment, { Moment } from 'moment';
import { AvailabilitySlot } from 'shared-types';

import { DatesSlider } from '@common/components';
import { getSliderDates } from '@features/Availability/helpers';
import { usePackageConfiguration } from '../../contexts';

export interface VisitDateFormProps {
  maxDaysInAdvance?: number;
  changeJourneyParam: (...args: any[]) => any;
  isTelephoneOnly: boolean;
  isLoading: boolean;
  timeslots: AvailabilitySlot[];
  namePrefix: string;
}

export const VisitDateForm: React.FC<VisitDateFormProps> = ({
  changeJourneyParam,
  isTelephoneOnly,
  isLoading,
  timeslots,
  namePrefix,
}) => {
  const { journeyParams, stayDuration } = usePackageConfiguration();
  const arrivalTimeName = `${namePrefix}.arrivalTime`;
  const visitDateName = `visitDate`;
  const form = useFormContext();
  const { control, setValue, watch } = form;
  const startDate = moment(journeyParams.fromDate).format('YYYY-MM-DD');
  const arrivalTime = watch(arrivalTimeName);

  const daysToFetch = new Array(7).fill('').map((_, index) => {
    return moment(arrivalTime?.startDateTime || startDate)
      .add(index, 'days')
      .format('YYYY-MM-DD');
  });

  const fetchingDates = isLoading ? daysToFetch : [];

  useEffect(() => {
    setValue(visitDateName, moment(journeyParams.fromDate).format('YYYY-MM-DD'));
  }, []);

  return (
    <Form>
      <Controller
        name={visitDateName}
        control={control}
        render={({ field: { onChange, value } }) => {
          const handleChange = (v: Moment) => {
            onChange(v.toString());
            setValue(arrivalTimeName, null);
            changeJourneyParam('spaDate', v);
          };
          return (
            <DatesSlider
              input={{
                value: moment(value),
                onChange: handleChange,
              }}
              dates={getSliderDates(timeslots, startDate, stayDuration, true)}
              hasPrices={false}
              visitDate={moment(value)}
              loadingDates={fetchingDates}
              telephoneOnly={isTelephoneOnly}
              isLoading={isLoading}
              checkAllDays
            />
          );
        }}
      />
    </Form>
  );
};
